import { useOpenedModals } from '@/shared/composables/useOpenedModals';
import { prefetchDateTimeModal } from '@/widgets/DateTimeModal';
import { prefetchConsultationModal } from '@/widgets/ConsultationModal';
import { prefetchConfirmationModal } from '@/widgets/ConfirmationModal';
import { prefetchCallbackModal } from '@/widgets/CallbackModal';
import { prefetchComplaintModal } from '@/widgets/ComplaintModal';
import { prefetchAppSuccessModal } from '@/shared/ui/AppSuccessModal';
import { LAWYER_MODAL_NAMES } from '@/pages/lawyer/model/types/lawyerModals';
import type { UseOpenedModalsReturn } from '@/shared/model/types/useOpenedModals';

const prefetchLawyerModals = (): void => {
  prefetchDateTimeModal();
  prefetchConsultationModal();
  prefetchConfirmationModal();
  prefetchCallbackModal();
  prefetchComplaintModal();
  prefetchAppSuccessModal();
};

export const useLawyerModals = (): UseOpenedModalsReturn =>
  useOpenedModals(LAWYER_MODAL_NAMES, prefetchLawyerModals);

export default useLawyerModals;
